import * as actionTypes from "./types";

const initialState = {
  loading: false,
  success: false,
  error: null,
  listCashiers: null,
  crudSuccess: false,
  crudError: null,
};

const listUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LIST_CASHIER_INITIATED: {
      return { ...state, loading: true };
    }
    case actionTypes.LIST_CASHIER_SUCCESS: {
      return {
        ...state,
        loading: false,
        listCashiers: action.payload,
        success: true,
        error: null,
      };
    }
    case actionTypes.LIST_CASHIER_FAILED: {
      return {
        ...state,
        loading: false,
        listCashiers: null,
        success: false,
        error: action.payload,
      };
    }

    //** CreateCahsier  */
    case actionTypes.CREATE_CASHIER_INITIATED: {
      return {
        ...state,
        loading: true,
        crudSuccess: false,
      };
    }
    case actionTypes.CREATE_CASHIER_SUCCESS: {
      return {
        ...state,
        loading: false,
        crudSuccess: true,
        crudError: null,
      };
    }
    case actionTypes.CREATE_CASHIER_FAILED: {
      return {
        ...state,
        loading: false,
        crudSuccess: false,
        crudError: action.payload,
      };
    }

    // ***** Update Cashier
    case actionTypes.UPDATE_CASHIER_INITIATED: {
      return {
        ...state,
        loading: true,
        crudSuccess: false,
      };
    }
    case actionTypes.UPDATE_CASHIER_SUCCESS: {
      return {
        ...state,
        loading: false,
        crudSuccess: true,
        crudError: null,
      };
    }
    case actionTypes.UPDATE_CASHIER_FAILED: {
      return {
        ...state,
        loading: false,
        crudSuccess: false,
        crudError: action.payload,
      };
    }

    // ** Delete Cashier
    case actionTypes.DELETE_CASHIER_INITIATED: {
      return {
        ...state,
        loading: true,
        crudSuccess: false,
      };
    }
    case actionTypes.DELETE_CASHIER_SUCCESS: {
      return {
        ...state,
        loading: false,
        crudSuccess: true,
        crudError: null,
      };
    }
    case actionTypes.DELETE_CASHIER_FAILED: {
      return {
        ...state,
        loading: false,
        crudSuccess: false,
        crudError: action.payload,
      };
    }

    // ** reset errors
    case actionTypes.RESET_ERRORS: {
      return {
        ...state,
        crudError: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default listUserReducer;
